
































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { create } from 'domain'
import { answerItemBodyParser } from "../../../../helpers/question-parser";
import AnswerItem from "../../models/answer_item";

@Component({})
export default class QuestionRadio extends Vue {
  @Prop({ default: [] }) list: Array<any>
  @Prop({ default: '' }) value: string
  @Prop({ default: '' }) trueBgr: string
  @Prop({ default: '' }) falseBgr: string
  @Prop({ default: false }) readonly: boolean
  @Prop({ default: () => {} }) callBackChange: Function
  @Prop({ default: '' }) color: string
  radios: string = ''

  @Watch('value')
  changeValue(val, oldVal) {
    console.log("Radio -> changeValue -> this.radios", val)
    console.log("Radio -> changeValue -> this.radios", oldVal)
    if (val !== oldVal) {
      this.radios = val
    }
  }

  created() {
    if (this.value.length) {
      this.radios = this.value
    }
  }

  getStyle(item) {
    if (this.trueBgr && item.correct) {
      return {
        'background-color': this.trueBgr
      }
    }
    if (this.falseBgr && !item.correct) {
      return {
        'background-color': this.falseBgr
      }
    }
    if (this.color != '') {
      return {
        'background-color': this.color
      }
    }
  }

  onChange(val) {
    this.callBackChange(val)
  }

  parserBody(answerItem: AnswerItem){
    return answerItemBodyParser(answerItem.body)
  }
}
